import type { ReactNode } from 'react';
import './EmptyState.css';

/**
 * An empty room, an empty home screen and a failed link import are normal
 * states, not errors. One line naming what goes here, and the button that
 * puts it there. No apology, no illustration.
 */
export function EmptyState({
  title,
  line,
  action,
}: {
  title: string;
  line: string;
  action?: ReactNode;
}) {
  return (
    <div className="empty-state">
      <h2 className="empty-state__title">{title}</h2>
      <p className="empty-state__line">{line}</p>
      {action !== undefined && <div className="empty-state__action">{action}</div>}
    </div>
  );
}
